import Rest from '@/services/Rest';

/**
 * @typedef {CertifyService}
 */
export default class CertifyService extends Rest {
    /**
     * @type {String}
     */
    static resource = 'certificate'
}